module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark--dark-8bd9f871a4d38282caf3dfb0a164674a.png";